export type FollowUpState = 'none' | 'overdue' | 'soon' | 'later';

export function followUpState(date: string | null | undefined, today: Date = new Date()): FollowUpState {
  if (!date) return 'none';
  const t = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const [y, m, d] = date.split('-').map(Number);
  if (!y || !m || !d) return 'none';
  const days = Math.round((Date.UTC(y, m - 1, d) - t) / 86_400_000);
  if (days < 0) return 'overdue';
  if (days <= 7) return 'soon';
  return 'later';
}
